import { VStack } from 'ui_2';
import { SelectedAccount } from './SelectedAccount';
import { PARCBalance } from './PARCBalance';
import { usePuzzleGameContext } from '@src/providers/puzzleProvider';

export const AccountAndParcBalance = ({
  gameActive,
}: {
  gameActive: boolean;
}) => {
  const { account } = usePuzzleGameContext();

  if (!account) return undefined;

  return (
    <VStack className='gap-4'>
      {account && (
        <div>
          <SelectedAccount account={account} />
        </div>
      )}
      <PARCBalance gameActive={gameActive} />
    </VStack>
  );
};
